module.exports = __webpack_public_path__ + "img/服务一体化.f4bcb7fb.png";